module.exports = __webpack_public_path__ + "static/media/wallyNoContacts.39f6fe82.svg";